import { styled } from '@styledComponents';
import { themeColumnWidth, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { CTALink } from '@components/CTALink';
import { animationTransition } from '@utils/animationTransition';

export const StorefrontGridWrapper = styled.div`
  width: 100%;
  margin-top: ${themeSpace(-9)};
  ${themeMediaQuery('sm')} {
    margin-top: ${themeSpace(-10)};
  }
`;
export const StyledStorefrontCell = styled.div`
  margin-top: ${themeSpace(9)};
  ${themeMediaQuery('sm')} {
    margin-top: ${themeSpace(10)};
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ECardWrapper = styled.div<{ $isHovered: boolean }>`
  min-width: 240px;
  min-height: 240px;
  width: 75vmin;
  height: 75vmin;
  max-width: 350px;
  max-height: 350px;
  ${themeMediaQuery('sm')} {
    min-width: unset;
    min-height: unset;
    max-width: unset;
    max-height: unset;
    width: ${themeColumnWidth('sm', 2)};
    height: ${themeColumnWidth('sm', 2)};
  }
  ${themeMediaQuery('md')} {
    width: ${themeColumnWidth('md', 3)};
    height: ${themeColumnWidth('md', 3)};
  }
  transform: scale(${({ $isHovered }) => ($isHovered ? 1.05 : 1.001)});
  transition: ${animationTransition('transform')};
`;

export const ECardTitle = styled(Text)`
  margin-top: ${themeSpace(7)};
`;

export const CreateLinkNoHoverDevices = styled(CTALink)`
  margin-top: ${themeSpace(5)};
  @media (hover: hover) {
    display: none;
  }
`;
